import React, { useState } from "react";
import DoctorLayout from "../../Layouts/Doctor/DoctorLayout";

export default function DoctorProfile() {
    const [formData, setFormData] = useState({
        name: "Dr. Mithra",
        specialization: "Cardiology",
        email: "mithra@hospital.com",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    return (
        <DoctorLayout>
            <div className="row g-4">
                <div className="col-12">
                    <div className="card border rounded-4 shadow-sm">
                        <div className="card-body p-4 p-lg-5">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <label className="form-label fw-semibold mb-1">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label fw-semibold mb-1">
                                            Specialization
                                        </label>
                                        <input
                                            type="text"
                                            name="specialization"
                                            className="form-control"
                                            value={formData.specialization}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label fw-semibold mb-1">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100 btn-sm fw-bold py-3 rounded-3"
                                        >
                                            Update Profile
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </DoctorLayout>
    );
}
